import {
  createSystem,
  defaultConfig,
  defineConfig,
  defineStyle,
} from "@chakra-ui/react";
import colors from "./foundation/colors";
import { semanticTokens } from "./semantic";
import { menuRecipe } from "./recipes/menuRecipe";

const linkBaseStyle = defineStyle({
  base: {
    textDecoration: "none !important",
    _hover: {},
    _focus: {
      outline: "none",
    },
  },
});

const config = defineConfig({
  theme: {
    tokens: {
      // fonts: {
      //   body: { value: "Inter, sans-serif" },
      //   heading: { value: "Inter, sans-serif" },
      //   mono: { value: "Inter, monospace" },
      // },
      // fontSizes: {
      //   xs: { value: "0.75rem" },
      //   sm: { value: "0.875rem" },
      //   md: { value: "1rem" },
      //   lg: { value: "1.125rem" },
      //   xl: { value: "1.25rem" },
      //   "2xl": { value: "1.5rem" },
      //   "3xl": { value: "1.875rem" },
      //   "4xl": { value: "2.25rem" },
      //   "5xl": { value: "3rem" },
      //   "6xl": { value: "3.75rem" },
      //   "7xl": { value: "4.5rem" },
      //   "8xl": { value: "6rem" },
      //   "9xl": { value: "8rem" },
      // },
      breakpoints: {},
      colors,
    },

    semanticTokens,
    recipes: {
      link: linkBaseStyle,
      // button: buttonRecipe,
      // menu: menuRecipe,
    },
    slotRecipes: {
      menu: menuRecipe,
    },
  },
  globalCss: {
    // "html, body, *": {
    //   margin: 0,
    //   padding: 0,
    //   fontFamily: "body",
    // },
    "[data-focus], [data-focus-visible]": {
      outline: "0 !important",
      boxShadow: "none !important",
    },
    //    // ✨ Menu trigger ka border/shadow kill (component-wide)
    // '[data-scope="menu"][data-part="trigger"]': {
    //   border: "0 !important",
    //   outline: "0 !important",
    //   boxShadow: "none !important",
    // },
    // // Optional: Avatar ke aas-paas koi border na aaye
    // '[data-scope="avatar"][data-part="root"]': {
    //   border: "0 !important",
    //   boxShadow: "none !important",
    // },

    // "[role=button]": { border: 0 },
  },
  preflight: true,
});

const system = createSystem(defaultConfig, config);
export default system;

// const config = defineConfig({
//   theme: {
//     recipes: {
//       link: defineRecipe({
//         base: {
//           textDecoration: "none !important",
//           //   outline: "none",
//           _hover: {
//             // boxShadow: "none",
//             // outline: "none",
//             // textDecoration: "none !important",
//           },
//           _focus: {
//             // boxShadow: "none",
//             outline: "none",
//             // textDecoration: "none",
//           },
//         },
//       }),
//     },
//     tokens: {
//       breakpoints: {},
//     },
//   },
//   globalCss: {},
// });
